import React, { FC } from 'react';
import { TypeCode } from '../../../../../../../../interfaces/Notification';
import { StyledCheckCircleIcon, StyledWarningIcon, StyledDiv } from './NotificationType.styles';

export interface NotificationTypeProps {
  type: TypeCode;
}

const NotificationType: FC<NotificationTypeProps> = ({ type }) => {
  if (type !== 'confirmation' && type !== 'actionrequired') return null;
  let icon: JSX.Element;

  if (type === 'confirmation') icon = (<StyledCheckCircleIcon />);
  if (type === 'actionrequired') icon = (<StyledWarningIcon />);

  return (<StyledDiv>{icon}</StyledDiv>);
};

export default NotificationType;
